var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('theme-provider',{staticClass:"fill-height",attrs:{"theme":"dark"}},[_c(_setup.MysteryBoxExchangeDialog,{attrs:{"show":_setup.showModal,"item":_setup.currentRewardGyriItem},on:{"closed":_setup.closed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }